import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Dropdown, Table, Badge, Pagination } from 'react-bootstrap';

const FormObat = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [activeMenu, setActiveMenu] = useState('');
  const [time, setTime] = useState({ date: '', clock: '' });

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);

    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      const parsedMenu = JSON.parse(savedMenu);
      setMenus(parsedMenu);
      if (parsedMenu.length > 0) setActiveMenu(parsedMenu[0].id_mn);
    }

    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const getMenuIcon = (menuName) => {
    switch (menuName.toUpperCase()) {
      case 'MASTER':        return 'bi-folder2-open';
      case 'GUDANG':        return 'bi-box-seam';
      case 'ADM GUDANG':    return 'bi-building-gear';
      case 'APOTEKER':      return 'bi-prescription2';
      case 'ADMINISTRATOR': return 'bi-person-workspace';
      case 'SETTING':       return 'bi-sliders';
      default:              return 'bi-grid-1x2';
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div style={styles.appContainer}>

      {/* ══════════════ NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home">
            <i className="bi bi-layers-half me-2 text-warning"></i>
            <span className="fw-bold text-white">Solusi Integrasi Layanan Kesehatan ( SILK )</span>
          </a>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-2">
              {menus.map((item) => {
                const isActive = location.pathname === item.lnk;
                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a
                      className={`nav-link-custom ${isActive ? 'active' : ''}`}
                      href={`#${item.des_mn.toLowerCase().replace(/\s+/g, '-')}`}
                      onClick={() => setActiveMenu(item.id_mn)}
                      style={{ ...styles.navLinkCustom, ...(isActive ? styles.navLinkActive : {}) }}
                    >
                      <i className={`bi ${getMenuIcon(item.des_mn)}`}></i>
                      {item.des_mn.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
              <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
                <div className="fw-semibold" style={{ fontSize: '0.8rem' }}>{time.date}</div>
                <div className="text-warning" style={{ fontSize: '0.7rem' }}>{time.clock}</div>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle
                  as="div" role="button"
                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-3 custom-profile-toggle"
                  style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center bg-warning text-dark fw-bold rounded-circle shadow-sm"
                    style={{ width: '32px', height: '32px', fontSize: '0.85rem' }}
                  >
                    {username ? username.charAt(0).toUpperCase() : 'A'}
                  </div>
                  <div className="d-none d-md-block text-start">
                    <div className="text-white fw-semibold lh-1" style={{ fontSize: '0.85rem' }}>{username}</div>
                    <div className="text-white-50 mt-1" style={{ fontSize: '0.7rem' }}>Online</div>
                  </div>
                  <i className="bi bi-chevron-down text-white-50 ms-1 small"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow border-0 mt-2 py-2 style-dropdown-menu" style={{ minWidth: '180px', borderRadius: '10px' }}>
                  <Dropdown.Item onClick={handleLogout} className="py-2 text-danger small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-box-arrow-right"></i> Keluar Aplikasi
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </nav>

      {/* ══════════════ MAIN CONTENT ══════════════ */}
      <div style={styles.mainContent} className="p-2">
        <Row className="g-3 flex-grow-0">
          <Col xl={12}>
            <Card style={styles.mainCard} className="border-0 shadow-sm">

              {/* ── Header Action Bar ── */}
              <div
                style={{ ...styles.cardHeader, ...styles.bgMenuHeader }}
                className="d-flex flex-wrap justify-content-between align-items-center px-3 py-2 border-bottom"
              >
                {/* Judul + Info Badge */}
                <div className="d-flex align-items-center gap-2 my-1 flex-wrap">
                  <span className="fw-bold text-white" style={{ fontSize: '0.88rem', letterSpacing: '0.3px' }}>
                    <i className="bi bi-clipboard2-check me-2"></i>MASTER DATA BARANG
                  </span>
                  {location.state?.info && (
                    <span style={{
                      fontSize: '0.68rem', fontWeight: 400,
                      color: 'rgba(255,255,255,0.75)',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '20px', padding: '1px 10px'
                    }}>
                      <i className="bi bi-info-circle me-1"></i>{location.state.info}
                    </span>
                  )}
                </div>

                {/* Tombol Aksi */}
                <div className="d-flex align-items-center gap-2 my-1">
                  <div className="btn-group shadow-sm" role="group">
                    <button type="button" className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                      style={styles.actionBtn}>
                      <i className="bi bi-check2-all"></i><span>Approval Baru</span>
                    </button>
                    <button type="button" className="btn btn-success btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                      style={styles.actionBtn}>
                      <i className="bi bi-hdd-fill"></i><span>Simpan</span>
                    </button>
                    <button type="button" className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                      style={styles.actionBtn}>
                      <i className="bi bi-files"></i><span>Salin Komposisi</span>
                    </button>
                    <button type="button" className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                      style={styles.actionBtn}>
                      <i className="bi bi-plus-circle"></i><span>Input Komposisi</span>
                    </button>
                    <button type="button" className="btn btn-warning btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                      style={{ ...styles.actionBtn, color: '#92400e' }}>
                      <i className="bi bi-hourglass-bottom"></i><span>End Of Life</span>
                    </button>
                    <button type="button" className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                      style={styles.actionBtn}>
                      <i className="bi bi-arrow-counterclockwise text-warning"></i><span>Bersihkan</span>
                    </button>
                  </div>

                  {/* Tombol Home */}
                  <button type="button"
                    className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1 fw-semibold shadow-sm"
                    onClick={() => navigate('/home')}
                    style={styles.actionBtn}>
                    <i className="bi bi-house-door"></i><span>Home</span>
                  </button>
                </div>
              </div>

              {/* ── Form Body ── */}
              <Card.Body style={styles.cardBody}>

                {/* SEKSI: Informasi Utama */}
                <div style={styles.sectionWrapper} className="mb-2">
                  <div style={styles.sectionTitle}>
                    <i className="bi bi-pencil-square me-2"></i>Informasi Utama Obat
                  </div>
                  <div className="p-2">
                    {/* Baris 1 */}
                    <Row className="g-2 mb-2">
                      <Col xl={3} md={6}>
                        <label style={formStyles.formLabel}>Kode | Nama Obat<span style={formStyles.requiredStar}>*</span></label>
                        <div className="input-group input-group-sm">
                          <input type="text" className="form-control fw-bold" style={{ maxWidth: '80px', ...formStyles.formControl }} defaultValue="00000070" />
                          <input type="text" className="form-control" style={formStyles.formControl} defaultValue="Amoxsan 500" />
                        </div>
                      </Col>
                      <Col xl={2} md={3}>
                        <label style={formStyles.formLabel}>Prinsipal</label>
                        <select className="form-select form-select-sm" style={formStyles.formControl}>
                          <option>Sanbe Farma</option>
                        </select>
                      </Col>
                      <Col xl={2} md={3}>
                        <label style={formStyles.formLabel}>Generik</label>
                        <select className="form-select form-select-sm" style={formStyles.formControl}>
                          <option>Non Generik</option>
                        </select>
                      </Col>
                      <Col xl={2} md={6}>
                        <label style={formStyles.formLabel}>Golongan</label>
                        <select className="form-select form-select-sm" style={formStyles.formControl}>
                          <option>G - Keras [Merah]</option>
                        </select>
                      </Col>
                      <Col xl={3} md={6}>
                        <label style={formStyles.formLabel}>Golongan Terapi</label>
                        <input type="text" className="form-control form-control-sm" style={formStyles.formControl} defaultValue="Penicillins" />
                      </Col>
                    </Row>

                    {/* Baris 2 */}
                    <Row className="g-2 mb-2">
                      <Col xl={3} md={6}>
                        <label style={formStyles.formLabel}>Kelas Terapi</label>
                        <input type="text" className="form-control form-control-sm" style={formStyles.formControl} defaultValue="Anti-Infectives [Systemic]" />
                      </Col>
                      <Col xl={2} md={6}>
                        <label style={formStyles.formLabel}>Satuan Beli<span style={formStyles.requiredStar}>*</span></label>
                        <input type="text" className="form-control form-control-sm" style={formStyles.formControl} defaultValue="Box | 100" />
                      </Col>
                      <Col xl={2} md={4} sm={6}>
                        <label style={formStyles.formLabel}>H.N.A Beli<span style={formStyles.requiredStar}>*</span></label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-light text-muted" style={{ fontSize: '0.68rem', padding: '0.2rem 0.35rem' }}>Rp.</span>
                          <input type="text" className="form-control text-end" style={formStyles.formControl} defaultValue="320,000" />
                        </div>
                      </Col>
                      <Col xl={2} md={4} sm={6}>
                        <label style={formStyles.formLabel}>H.D.A Beli<span style={formStyles.requiredStar}>*</span></label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-light text-muted" style={{ fontSize: '0.68rem', padding: '0.2rem 0.35rem' }}>Rp.</span>
                          <input type="text" className="form-control text-end" style={formStyles.formControl} defaultValue="352,000" />
                        </div>
                      </Col>
                      <Col xl={1} md={4}>
                        <label style={formStyles.formLabel}>Isi | Konv<span style={formStyles.requiredStar}>*</span></label>
                        <input type="text" className="form-control text-center form-control-sm" style={formStyles.formControl} defaultValue="1" />
                      </Col>
                      <Col xl={2} md={6}>
                        <label style={formStyles.formLabel}>Satuan Jual<span style={formStyles.requiredStar}>*</span></label>
                        <input type="text" className="form-control form-control-sm" style={formStyles.formControl} defaultValue="Box | 100" />
                      </Col>
                    </Row>

                    {/* Baris 3 */}
                    <Row className="g-2 align-items-end">
                      <Col xl={2} md={4} sm={6}>
                        <label style={formStyles.formLabel}>H.N.A Jual<span style={formStyles.requiredStar}>*</span></label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-light text-muted" style={{ fontSize: '0.68rem', padding: '0.2rem 0.35rem' }}>Rp.</span>
                          <input type="text" className="form-control text-end" style={formStyles.formControl} defaultValue="320,000" />
                        </div>
                      </Col>
                      <Col xl={2} md={4} sm={6}>
                        <label style={formStyles.formLabel}>H.D.A Jual<span style={formStyles.requiredStar}>*</span></label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-light text-muted" style={{ fontSize: '0.68rem', padding: '0.2rem 0.35rem' }}>Rp.</span>
                          <input type="text" className="form-control text-end" style={formStyles.formControl} defaultValue="352,000" />
                        </div>
                      </Col>
                      <Col xl={2} md={4}>
                        <label style={formStyles.formLabel}>Pabrik</label>
                        <input type="text" className="form-control form-control-sm" style={formStyles.formControl} defaultValue="Caprifarmindo" />
                      </Col>
                      <Col xl={6} md={12} className="d-flex flex-wrap gap-3 pb-1 ps-2">
                        <div className="form-check m-0">
                          <input className="form-check-input" type="checkbox" id="chkKronis" defaultChecked style={formStyles.formCheckInput} />
                          <label className="form-check-label" htmlFor="chkKronis" style={formStyles.formCheckLabel}>Kronis / Paket</label>
                        </div>
                        <div className="form-check m-0">
                          <input className="form-check-input" type="checkbox" id="chkAktif" defaultChecked style={formStyles.formCheckInput} />
                          <label className="form-check-label" htmlFor="chkAktif" style={formStyles.formCheckLabel}>Status Aktif</label>
                        </div>
                        <div className="form-check m-0">
                          <input className="form-check-input" type="checkbox" id="chkFormularium" style={formStyles.formCheckInput} />
                          <label className="form-check-label" htmlFor="chkFormularium" style={formStyles.formCheckLabel}>Formularium RS</label>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                {/* SEKSI: Tabel Komposisi */}
                <div style={styles.sectionWrapper}>
                  <div style={{ ...styles.sectionTitle, background: 'linear-gradient(135deg, #d3eff2, #e6f7f9)', color: '#2d555c' }}>
                    <i className="bi bi-capsule me-2"></i>Komposisi Zat Aktif Obat
                  </div>
                  <div style={{ flex: 1, overflowY: 'auto' }}>
                    <Table hover size="sm" className="align-middle mb-0 text-nowrap" style={{ fontSize: '0.72rem' }}>
                      <thead style={styles.tableHead}>
                        <tr>
                          <th style={styles.th}>Kode</th>
                          <th style={styles.th}>Komposisi</th>
                          <th style={{ ...styles.th, textAlign: 'center' }}>Qty</th>
                          <th style={styles.th}>Kode</th>
                          <th style={styles.th}>Satuan</th>
                          <th style={{ ...styles.th, textAlign: 'center', width: '50px' }}>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-secondary fw-medium" style={styles.td}>135</td>
                          <td className="fw-semibold text-dark" style={styles.td}>Amoxicillin Trihydrate</td>
                          <td className="text-center" style={styles.td}>500</td>
                          <td className="text-secondary" style={styles.td}>048</td>
                          <td style={styles.td}>
                            <Badge bg="dark" className="bg-opacity-10 text-dark px-2 py-1" style={{ fontSize: '0.65rem' }}>mg</Badge>
                          </td>
                          <td className="text-center" style={styles.td}>
                            <button className="btn btn-link link-danger p-0 border-0" title="Hapus" style={{ fontSize: '0.75rem' }}>
                              <i className="bi bi-trash-fill"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  {/* Footer tabel */}
                  <div className="d-flex justify-content-between align-items-center px-3 py-1"
                    style={{ background: '#f8fafc', borderTop: '1px solid #edf2f7', fontSize: '0.68rem', color: '#64748b' }}>
                    <div>Total: <span className="text-dark fw-bold">1 Data</span></div>
                    <Pagination size="sm" className="mb-0">
                      <Pagination.Prev disabled />
                      <Pagination.Item active>{1}</Pagination.Item>
                      <Pagination.Next disabled />
                    </Pagination>
                  </div>
                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f0f4f8 0%, #e8edf3 100%)',
    display: 'flex',
    flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.4rem 1rem',
    flexShrink: 0,
  },
  navLinkCustom: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '0.78rem',
    fontWeight: 500,
    padding: '0.3rem 0.6rem',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
    textDecoration: 'none',
    transition: 'all 0.2s',
  },
  navLinkActive: {
    color: '#ffffff',
    background: 'rgba(255,255,255,0.12)',
  },
  mainContent: {
    flex: 1,
    overflow: 'auto',
    padding: '0.5rem',
  },
  mainCard: {
    borderRadius: '12px',
    background: '#ffffff',
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.5rem 1rem',
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.82rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  cardBody: {
    padding: '0.75rem',
    background: '#f8fafc',
  },
  sectionWrapper: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitle: {
    background: 'linear-gradient(135deg, #e0f2fe, #bae6fd)',
    color: '#0369a1',
    fontWeight: 600,
    fontSize: '0.78rem',
    padding: '0.35rem 0.75rem',
    display: 'flex',
    alignItems: 'center',
  },
  actionBtn: {
    fontSize: '0.73rem',
    borderRadius: '6px',
    border: '1px solid rgba(255,255,255,0.3)',
    padding: '0.25rem 0.6rem',
  },
  tableHead: {
    background: 'linear-gradient(135deg, #0f172a, #1e293b)',
    color: '#e2e8f0',
  },
  th: {
    padding: '0.4rem 0.6rem',
    fontWeight: 600,
    fontSize: '0.72rem',
    whiteSpace: 'nowrap',
    color: '#e2e8f0',
    background: 'transparent',
  },
  td: {
    padding: '0.3rem 0.6rem',
  },
};

const formStyles = {
  formLabel: {
    fontSize: '0.68rem',
    fontWeight: 600,
    color: '#4a5d60',
    marginBottom: '0.1rem',
    display: 'block',
  },
  requiredStar: { color: '#ef4444', marginLeft: '1px' },
  formControl: {
    fontSize: '0.72rem',
    borderRadius: '4px',
    padding: '0.2rem 0.35rem',
    border: '1px solid #cbd5e1',
    color: '#2c4043',
    height: 'calc(1.4em + 0.4rem + 2px)',
  },
  formCheckLabel: { fontSize: '0.68rem', fontWeight: 600, color: '#4a5d60', cursor: 'pointer' },
  formCheckInput: { width: '0.85rem', height: '0.85rem', cursor: 'pointer' },
};

export default FormObat;